import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Component, Vue } from 'vue-property-decorator';
import { EnumProp } from '../../utils/enumProp.js';
import { SpinnerSize } from './SpinnerSize.js';
import __vue_component__$1 from '../HseClickableIcon/HseClickableIcon.vue.js';
import { IconSize } from '../HseIcon/IconSize.js';
import __vue_component__ from '../../icons/action/delete/IconActionDelete.vue.js';

/**
 * @figma https://www.figma.com/file/cBHD57QcCt9WDT4e7e2B3w/hse_general_library?node-id=8796%3A0
 * @storybook /?path=/story/spinner-spinner--playground
 * @react /src-components-spinner
 * @reactStorybook /?path=/story/spinner-spinner--playground
 */
var HseSpinner = /** @class */ (function (_super) {
    __extends(HseSpinner, _super);
    function HseSpinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.radius = 20;
        _this.width = 2;
        return _this;
    }
    Object.defineProperty(HseSpinner.prototype, "iconSize", {
        get: function () {
            var _a;
            return (_a = {},
                _a[SpinnerSize.XL] = IconSize.medium,
                _a[SpinnerSize.XXL] = IconSize.large,
                _a[SpinnerSize.large] = IconSize.small,
                _a[SpinnerSize.medium] = IconSize.small,
                _a[SpinnerSize.small] = IconSize.small,
                _a)[this.size];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "sizePx", {
        get: function () {
            var _a;
            return (_a = {},
                _a[SpinnerSize.XXL] = 56,
                _a[SpinnerSize.XL] = 44,
                _a[SpinnerSize.large] = 32,
                _a[SpinnerSize.medium] = 24,
                _a[SpinnerSize.small] = 16,
                _a)[this.size];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "circumference", {
        get: function () {
            return 2 * Math.PI * this.radius;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "normalizedValue", {
        get: function () {
            if (this.done)
                return 100;
            if (!this.value || this.value < 0)
                return 0;
            if (this.value > 100)
                return 100;
            return typeof this.value === 'string' ? parseFloat(this.value) : this.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "strokeDashArray", {
        get: function () {
            return Math.round(this.circumference * 1000) / 1000;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "strokeDashOffset", {
        get: function () {
            return ((100 - this.normalizedValue) / 100) * this.circumference + 'px';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "strokeWidth", {
        get: function () {
            return (Number(this.width) / +this.sizePx) * (this.viewBoxSize || 1) * 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "viewBoxSize", {
        get: function () {
            return this.radius / (1 - Number(this.width) / +this.sizePx);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "checkmarkCheckStyle", {
        get: function () {
            var x = '50% - 4px';
            var y = '50% - 4px';
            if ([SpinnerSize.XL, SpinnerSize.XXL].includes(this.size)) {
                x = '50% - 5px';
                y = '50% - 5px';
            }
            return {
                transform: "translate(calc(" + x + "), calc(" + y + "))",
                strokeWidth: this.strokeWidth
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "IconActionDelete", {
        get: function () {
            return __vue_component__;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "component", {
        get: function () {
            return this.cancelable ? 'button' : 'div';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HseSpinner.prototype, "isLoading", {
        get: function () {
            return this.loading || this.indeterminate;
        },
        enumerable: false,
        configurable: true
    });
    HseSpinner.prototype.mounted = function () {
        this.warn();
    };
    HseSpinner.prototype.updated = function () {
        this.warn();
    };
    HseSpinner.prototype.warn = function () {
        var _a = this, size = _a.size, cancelable = _a.cancelable;
        if ((size === SpinnerSize.large ||
            size === SpinnerSize.medium ||
            size === SpinnerSize.small) &&
            cancelable) {
            // eslint-disable-next-line no-console
            console.warn('Использование пропа cancelable возможно только с SpinnerSize.XL и SpinnerSize.XXL');
        }
    };
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSpinner.prototype, "done", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], HseSpinner.prototype, "cancelable", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSpinner.prototype, "loading", void 0);
    __decorate([
        Prop({
            default: false
        }),
        __metadata("design:type", Boolean)
    ], HseSpinner.prototype, "indeterminate", void 0);
    __decorate([
        Prop(EnumProp(SpinnerSize.medium, SpinnerSize)),
        __metadata("design:type", String)
    ], HseSpinner.prototype, "size", void 0);
    __decorate([
        Prop({
            default: 0
        }),
        __metadata("design:type", Object)
    ], HseSpinner.prototype, "value", void 0);
    __decorate([
        Prop({
            default: function () { return ({
                cancelIcon: '',
                checkmark: ''
            }); }
        }),
        __metadata("design:type", Object)
    ], HseSpinner.prototype, "classes", void 0);
    HseSpinner = __decorate([
        Component({
            name: 'HseSpinner',
            components: {
                HseClickableIcon: __vue_component__$1
            }
        })
    ], HseSpinner);
    return HseSpinner;
}(Vue));

export default HseSpinner;
